export default {"src":"/_next/static/media/film-bg.713c032f.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};